import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class CourseElementModel extends Model 
{
	@attr name;
	@attr('boolean') isPublic;
	@attr order;
	@attr length;
	
	@belongsTo('intermediate-timing-point', {inverse: null, async: true}) IntermediateTimingPointId;
	@belongsTo('course', {inverse: 'courseElements', async: true}) CourseId;
}